/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userBusinessBanners.internal

import features.userBusinessBanners.models.UserBusinessBannersModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserBusinessBannersServiceImpl : UserBusinessBannersService {

    private val userBusinessBannersRequest = UserBusinessBannersRequest()

    override suspend fun getUserBusinessBanners(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<UserBusinessBannersModel> {
        return userBusinessBannersRequest.getUserBusinessBanners(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
